'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dotObject = require('dot-object');

var _dotObject2 = _interopRequireDefault(_dotObject);

var _Sort = require('./Sort');

var _Sort2 = _interopRequireDefault(_Sort);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck3.default)(this, Table);
    return (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  (0, _createClass3.default)(Table, [{
    key: 'getSortProps',
    value: function getSortProps(field) {
      var isActive = this.props.sortBy === field.name;
      var isUp = this.props.sortType === 'ASC';
      return {
        isActiveUp: isActive && isUp,
        isActiveDown: isActive && !isUp
      };
    }
  }, {
    key: 'toggleSort',
    value: function toggleSort(field) {
      var isActive = this.props.sortBy === field.name;
      var isUp = this.props.sortType === 'ASC';
      var type = isActive ? isUp ? 'DESC' : 'ASC' : typeof field.sort === 'string' ? field.sort : 'ASC';
      this.props.setSort(field.name, type);
    }
  }, {
    key: 'renderHead',
    value: function renderHead() {
      var _this2 = this;

      var cols = this.props.fields.map(function (field, index) {
        var sort = field.sort ? _react2.default.createElement(_Sort2.default, _this2.getSortProps(field)) : null;
        var style = field.sort ? 'paginated-th-sort' : '';
        var onClick = field.sort ? function () {
          return _this2.toggleSort(field);
        } : undefined;
        return _react2.default.createElement(
          'th',
          { key: index, className: style, onClick: onClick },
          sort,
          field.title
        );
      });
      return _react2.default.createElement(
        'tr',
        null,
        cols
      );
    }
  }, {
    key: 'renderValue',
    value: function renderValue(item, field, index) {
      var value = _dotObject2.default.pick(field.name, item);

      if (field.render) {
        try {
          return field.render(item, value, index);
        } catch (error) {
          console.error('Error rendering field "' + field.name + '":', error);
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'i',
              null,
              'Error'
            )
          );
        }
      }

      return value;
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this3 = this;

      return this.props.items.map(function (item, index) {
        var isSelected = _this3.props.selectedItemId === item._id;
        var cols = _this3.props.fields.map(function (field, index2) {
          return _react2.default.createElement(
            'td',
            { key: index2 },
            _this3.renderValue(item, field, index)
          );
        });
        return _react2.default.createElement(
          'tr',
          { key: item._id, className: isSelected ? 'paginated-table-row selected' : 'paginated-table-row', onClick: function onClick() {
              return _this3.props.onSelect(item, index);
            } },
          cols
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'paginated-table table hoverable' },
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'thead',
            null,
            this.renderHead()
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this.renderBody()
          )
        )
      );
    }
  }]);
  return Table;
}(_react2.default.Component), _class.propTypes = {
  items: _propTypes2.default.array,
  fields: _propTypes2.default.array.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  sortBy: _propTypes2.default.string,
  sortType: _propTypes2.default.string,
  setSort: _propTypes2.default.func.isRequired,
  selectedItemId: _propTypes2.default.string
}, _temp);
exports.default = Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/Table/index.js
// module id = 1532
// module chunks = 85